/*
 * Copyright (c) Outright Mental (https://outrightmental.com/) All Rights Reserved.
 */

// vendor
import React from "react";
// app
import "./BoardPlayer.scss"
import DashQuantity from "./DashQuantity";
import {useDispatch, useSelector} from "react-redux";
import {doDepartmentOpen, selectPlayerData} from "../../engine/BoardEngine";
import {selectPlayerName} from "../../engine/GameEngine";
import theme from "../../theme";
import {MONEY,} from "../../constants";
import DashMessage from "./DashMessage";

/**
 BoardPlayer component renders the playable board for one player
 <p>
 @return {*}
 @param {
   playerId: Number
 } props
 */
export default function BoardPlayer(props) {
  const playerId = props.playerId;

  const dispatch = useDispatch();

  const
    playerOneDataSelector = selectPlayerData(playerId),
    playerOneData = useSelector(state => playerOneDataSelector(state));

  const
    playerOneNameSelector = selectPlayerName(playerId),
    playerOneName = useSelector(state => playerOneNameSelector(state));

  const
    handleDepartmentOpen = (type) => dispatch(doDepartmentOpen(type));

  return (
    <div className="board-player">
      <div className="sidebar">

        <DashQuantity
          unit="market share"
          color="#000000"
          backgroundColor="#ffffff"
          size={1}
          name={playerOneName}
          quantity={`${playerOneData.resources.marketShare}%`}
        />

        <DashQuantity
          unit="cash"
          backgroundColor={theme.greenHigh}
          size={0.8}
          quantity={MONEY.format(playerOneData.resources.cash)}
        />

        {/*<DashQuantity
          unit="cash"
          backgroundColor={theme.greenHigh}
          size={0.8}
          quantity={MONEY.format(playerOneData.resources.cash)}
        />*/}

        {/*
              <div className="section">
                {sectionHeader("Resources")}
                {sectionRow("Cash", )}
                {sectionRow("Sales", MONEY.format(playerOneData.resources.salesValue))}
              </div>
        */}

      </div>
      <div className="departments">
        {/*
      <div className="section">
        {sectionHeader("Departments")}
        {DEPARTMENT_TYPES.map(type => sectionDepartmentTypeRows(type))}
      </div>
      */}
      </div>
      <div className="messages">
        {
          playerOneData.messages.map(message => (<DashMessage key={message} message={message}/>))
        }
      </div>
    </div>
  );
};
